import AutocompleteField from 'components/forms/fields/autocomplete-field/autocomplete-field.component';
import { useRegions, UseRegionsOptions } from 'hooks/iso-3166.hooks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteBaseProps } from '../autocomplete-field/autocomplete-base/autocomplete-base.component';
import { CountryFieldProps } from '../country-field/country-field.component';

export type RegionFieldProps = {
  name?: string;
  label?: string;
  'data-testid'?: string;
  country?: string;
  countryIdKey?: CountryFieldProps['idKey'];
  idKey?: 'iso' | 'name';
} & UseRegionsOptions &
  Partial<AutocompleteBaseProps>;

const RegionField = ({
  name = 'region',
  label,
  'data-testid': dataTestId = 'RegionField',
  include,
  exclude,
  country,
  countryIdKey = 'iso',
  idKey = 'iso',
  ...rest
}: RegionFieldProps) => {
  const { t } = useTranslation();
  const regions = useRegions(country, { include, exclude, countryIdKey });
  const options = useMemo(
    () =>
      regions.map(region => ({
        id: region[idKey],
        label: region.name,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [regions],
  );
  const finalLabel = useMemo(
    () => label ?? t('forms.fields.region.label'),
    [label, t],
  );

  return (
    <AutocompleteField
      name={name}
      options={options}
      label={finalLabel}
      data-testid={dataTestId}
      {...rest}
    />
  );
};

export default React.memo(RegionField);
